import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateEmail,
    validAccountAndPassword
} from '@/util/validate'
import {baseUrl} from '@/config/env';


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门名称为1-30位中文'))
    } else {
        callback();
    }
}

const validatorEmail = (rule, value, callback) => {
    if (!validateEmail(value)) {
        callback(new Error('请输入正确的邮箱地址'))
    } else {
        callback();
    }
}
const validatorPassword = (rule, value, callback) => {
    if (!validAccountAndPassword(value)) {
        callback(new Error('请输入由数字和字母组成的6-16位密码'))
    } else {
        callback();
    }
}

export const stuffTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    // viewBtn: true,
    menuWidth: '300',
    labelWidth: '200',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "员工编号",
            prop: "code",
            placeholder: "请输入员工编号",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入员工编号"
            }]
        },{
            label: "员工名称",
            prop: "name",
            placeholder: "请输入员工名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "所属部门",
            prop: "departId",
            solt: true,
            formsolt: true,
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请选择所属部门"
            // }]
        },
        {
            label: "部门职位",
            prop: "departPositionId",
            solt: true,
            formsolt: true,
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请选择部门职位"
            // }]
        },
        {
            label: "初始积分",
            prop: "initPoint",
            placeholder: "请输入初始积分",
            type: 'number',
            hide:  true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入初始积分"
            }]
        },
        // {
        //     label: "单次申请积分上限",
        //     prop: "applyPointMax",
        //     placeholder: "请输入单次申请积分上限",
        //     hide:  true,
        //     type: 'number',
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "请输入单次申请积分上限"
        //     }]
        // },
        {
            label: "入职日期",
            prop: "entryDate",
            type: 'date',
            format: "yyyy-MM-dd",
            valueFormat: "timestamp",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择入职日期"
            }]
        },
        {
            label: "员工生日",
            prop: "birthDate",
            type: 'date',
            format: "yyyy-MM-dd",
            valueFormat: "timestamp",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择员工生日"
            }]
        },
        {
            label: "员工性别",
            prop: "gender",
            // span: 6,
            type: "radio",
            dicData: DIC.SEX,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择员工性别"
            }]
        },
        {
            label: "手机号码",
            prop: "mobile",
            placeholder: "请选择手机号码(将作为登录账号)",
            type: "input",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择手机号码(将作为登录账号)"
            }]
        },
        // {
        //     label: "邮箱",
        //     prop: "email",
        //     type: "input"
        // },
        {
            label: "登录密码",
            placeholder: "请输入员工的登录密码",
            prop: "password",
            hide:  true,
            type: "password",
            editVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                validator: validatorPassword
            }]
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            dicData: DIC.STATUS_STATE_MODEL,
            sortable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            max: 255
        }


    ]
};